import styled from "styled-components";
import { animFooterBtn, svgAnimOn, whiteDivOpa } from "./animations";

export const FastButtonDiv = styled.div<{
  isTurboOn: boolean;
  animOn: boolean;
}>`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 56px;
  height: 56px;
  border-radius: 28px;
  background-color: ${(p) => (p.isTurboOn ? "#ff3920" : "#ffb000")};
  color: ${(p) => (p.isTurboOn ? "#ffb000" : "#ff3920")};
  transition: background-color 500ms linear;
  font-size: 20px;
  cursor: pointer;
  animation: ${(p) => (p.animOn ? animFooterBtn : null)};
  &&.auto {
    svg {
      margin-left: 4px;
    }
  }
  svg {
    path {
      transform-origin: center top;
      stroke-dasharray: 43;
      stroke-dashoffset: 0;
      stroke: ${(p) => (p.isTurboOn ? "#ffb000" : "#ff3920")};

      animation: ${(p) => (p.isTurboOn ? svgAnimOn : null)};
    }
  }

  .white {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50px;
    background: #ffffff;
    opacity: 0;

    animation: ${(p) => (p.animOn ? whiteDivOpa : null)};
  }
`;
